import React from "react";
import "./LoaderLogo.css";

class LogoLoader extends React.Component {
  render() {
    const theme = this.props.theme;
    return (
      <svg
        className="raw_logo"
        width="50%"
        height="40%"
        viewBox="0 0 440 305"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          class="myHexagon"
          d="M293.545 167.405L229.5 204.381C227.025 205.81 223.975 205.81 221.5 204.381L157.455 167.405C154.98 165.976 153.455 163.335 153.455 160.476L153.455 86.5234C153.455 83.6653 154.98 81.0243 157.455 79.5952L221.5 42.6187C223.975 41.1896 227.025 41.1897 229.5 42.6187L293.545 79.5952C296.02 81.0243 297.545 83.6653 297.545 86.5234L297.545 160.476C297.545 163.335 296.02 165.976 293.545 167.405Z"
          stroke={theme.body}
          strokeWidth="4"
        />
        <path
          class="myHexagon"
          d="M147.455 73.5953L211.5 36.6188C213.975 35.1898 217.025 35.1898 219.5 36.6188L283.545 73.5953C286.02 75.0244 287.545 77.6654 287.545 80.5235L287.545 154.477C287.545 157.335 286.02 159.976 283.545 161.405L219.5 198.381C217.025 199.81 213.975 199.81 211.5 198.381L147.455 161.405C144.98 159.976 143.455 157.335 143.455 154.477L143.455 80.5235C143.455 77.6654 144.98 75.0244 147.455 73.5953Z"
          stroke={theme.body}
          strokeWidth="4"
        />
        <path
          class="letter"
          d="M180 123.968V132H160V123.968H166L163 116H150L147 123.968H153V132H135V123.968H141L150 92.4883H144V84.4561H175V92.4883H169L179 123.968H180ZM161 108.826L157 94.5049L153 108.826H161Z"
          stroke={theme.body}
          strokeWidth="3"
        />
        <path
          class="letter"
          d="M190 158V149.968H196V128.913H190V118.488H185V110.456H208V118.488H203V149.968H208V158H190ZM225 158V149.968H231V128.913H225V118.488H220V110.456H243V118.488H238V149.968H243V158H225ZM258 158V149.968H264V118.488H258V110.456H281V118.488H276V149.968H281V158H258Z"
          stroke={theme.body}
          strokeWidth="3"
        />
        
        {/* Signature: Mechdoud Mohammed */}
        <g className="signature-group">
          <text 
            x="220" 
            y="270" 
            fontFamily="cursive" 
            fontSize="28" 
            fill={theme.body}
            className="signature-text"
            textAnchor="middle"
          >
            Mechdoud Mohammed
          </text>
          
          {/* Ligne décorative sous la signature */}
          <path
            className="signature-line"
            d="M 100 275 Q 220 280 340 275"
            stroke={theme.body}
            strokeWidth="2"
            fill="none"
          />
        </g>

        <defs>
          <style>
            {`
              .signature-text {
                opacity: 0;
                animation: fadeInSignature 2s ease-in forwards 2s;
              }
              
              .signature-line {
                stroke-dasharray: 240;
                stroke-dashoffset: 240;
                animation: drawLine 1.5s ease-out forwards 2.5s;
              }

              @keyframes fadeInSignature {
                from {
                  opacity: 0;
                  transform: translateY(10px);
                }
                to {
                  opacity: 1;
                  transform: translateY(0);
                }
              }

              @keyframes drawLine {
                from {
                  stroke-dashoffset: 240;
                }
                to {
                  stroke-dashoffset: 0;
                }
              }

              .letter {
                opacity: 0;
                animation: fadein 2s linear forwards 2.5s;
              }

              @keyframes fadein {
                from {
                  opacity: 0;
                }
                to {
                  opacity: 1;
                }
              }

              .myHexagon {
                stroke-dasharray: 800;
                stroke-dashoffset: 800;
                animation: dash 4s linear forwards 0.5s;
              }

              @keyframes dash {
                from {
                  stroke-dashoffset: 800;
                }
                to {
                  stroke-dashoffset: 0;
                }
              }
            `}
          </style>
        </defs>
      </svg>
    );
  }
}

export default LogoLoader;